module.exports = __webpack_public_path__ + "img/kt-websitebanner-2.bb6bb821.png";